import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=4fddde56&scoped=true&"
import script from "./Cards.vue?vue&type=script&lang=ts&"
export * from "./Cards.vue?vue&type=script&lang=ts&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=4fddde56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fddde56",
  null
  
)

export default component.exports